<template>
  <v-card>
    <v-card-title>
      {{ title }}
      <v-spacer />
      <v-select
        v-if="exportButton"
        v-model="exportType"
        style="max-width: 10%; min-width: 150px"
        :items="exportTypes"
        :label="$t('common.export')"
        solo
        dense
        prepend-icon="mdi-file"
        @change="handleExport"
        @click:prepend="handleExport(exportType)"
        hide-details
      />
    </v-card-title>
    <v-card-text>
      <v-container fluid class="align-center justify-center fill-width">
        <v-data-table
          :headers="headers"
          :items="data"
          dense
          sort-by="createdAt"
        >
          <template v-for="h in headers" v-slot:[`item.${h.value}`]="props">
            <div
              v-if="isDate(props.item[h.value], h.value)"
              :key="'time ' + h.value"
            >
              {{ humanDate(props.item[h.value]) }}
            </div>
            <div
              v-else-if="isNumber(props.item[h.value])"
              :key="'number ' + h.value"
            >
              {{
                numberPrecision !== Infinity
                  ? +parseFloat(props.item[h.value]).toFixed(numberPrecision)
                  : props.item[h.value]
              }}
            </div>
            <div v-else :key="h.value">
              {{ props.item[h.value] }}
            </div>
          </template>
        </v-data-table>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import { DataTableExportTypes } from "@/_helpers/CsharpEnum";
import exportMixin from "@/_helpers/exportMixin";
import { isFinite, isDate } from "lodash-es";

export default {
  name: "SoDataTable",

  props: {
    title: {
      type: String,
      default: "",
    },

    headers: {
      default: () => [],
    },

    data: {
      default: () => [],
    },

    numberPrecision: {
      type: Number,
      default: Infinity,
    },

    exportButton: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [exportMixin],

  computed: {
    exportTypes() {
      return Object.values(DataTableExportTypes)
        .filter((x) => x !== DataTableExportTypes.EXCEL) // TODO Remove when Excel export is implemented
        .map((value) => ({
          text: this.$t(`dataTable.dataExportTypes.${value}`),
          value,
        }));
    },
  },

  data() {
    return {
      exportType: undefined,
      columnsUsingDate: ["createdAt", "updatedAt", "executedAt"],
    };
  },

  methods: {
    ...mapActions("alert", ["success", "error"]),

    isDate(input, headerValue) {
      return isDate(input) || this.columnsUsingDate.includes(headerValue);
    },

    isNumber(input) {
      return isFinite(input);
    },

    handleExport(type) {
      if (this.data.length == 0 || this.headers.length == 0) {
        this.error(this.$t("dataTable.errors.noData"));
        return;
      }

      switch (type) {
        case DataTableExportTypes.CSV:
          this.exportTableAsCSV(this.headers, this.data, `DataTable`);
          break;
        case DataTableExportTypes.JSON:
          this.exportTableAsJson(this.headers, this.data, `DataTable`);
          break;
        // case DataTableExportTypes.EXCEL:
        //   break;
        default:
          console.error(
            `Can't export type: ${
              this.$t("dataTable.dataExportTypes." + type) ?? type
            }`
          );
          this.error(this.$t("dataTable.errors.unSupportedType"));
          break;
      }
    },
  },
};
</script>
